const fastcompany = {
  'fb:pages': '5942134076',
  'og:site_name': 'Fast Company',
  'fb:app_id': '178479832213933',
  'fb:admins': '100000062710915',
  'article:publisher': 'https://www.facebook.com/FastCompany',
  'twitter:site': '@FastCompany',
  'twitter:domain': 'fastcompany.com',
  imageUrl:
    'https://a.fastcompany.net/image/upload/v1485296620/fcweb/fastcompany-seo.png'
};

const fastcodesign = {
  'fb:pages': '107619279310824',
  'og:site_name': 'Co.Design',
  'fb:app_id': '123388861116012',
  'fb:admins': '100000062710915',
  'article:publisher': 'https://www.facebook.com/FastCoDesign',
  'twitter:site': '@FastCoDesign',
  'twitter:domain': 'fastcodesign.com',
  imageUrl:
    'https://a.fastcompany.net/image/upload/v1485296802/fcweb/codesign-seo.png'
};

export default {
  fastcompany,
  fastcodesign
};



// WEBPACK FOOTER //
// ./src/utils/seo_utils/site_data_util.js